var default_styles_default = {
  "button_container": "alQOu",
  "button_margin": "DOFF0",
  "button_text": "ez3YE",
  "button_size_content": "_9xejr"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
